
import { combineReducers } from 'redux';
import applicationData from './reducer';

export default combineReducers({
    applicationData
})
